import { _get, _post, _delete } from '../../http'
const menu = {
  get: (data) => _get('admin/menu/permissionList', data),
  add: (data) => _post('admin/menu/add', data),
  update: (data) => _post('admin/menu/update', data),
  delete: (data) => _post('admin/menu/remove', data),
}
export default menu
